import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';
import type { PortfolioHealthSlice } from '@/hooks/useSyncedData';

const COLORS = ['hsl(160, 84%, 39%)', 'hsl(38, 92%, 50%)', 'hsl(346, 77%, 50%)'];

interface PortfolioChartProps {
  data: PortfolioHealthSlice[];
}

const PortfolioChart = ({ data: portfolioHealthData }: PortfolioChartProps) => {
  const total = portfolioHealthData.reduce((sum, item) => sum + item.value, 0);

  if (total === 0) {
    return (
      <div className="masira-card masira-slide-up" style={{ animationDelay: '400ms' }}>
        <h3 className="font-semibold text-foreground mb-4">Portfolio Health</h3>
        <p className="text-sm text-muted-foreground py-12 text-center">No projects synced yet.</p>
      </div>
    );
  }

  return (
    <div className="masira-card masira-slide-up" style={{ animationDelay: '400ms' }}>
      <h3 className="font-semibold text-foreground mb-4">Portfolio Health</h3>

      <div className="h-48 md:h-64">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={portfolioHealthData}
              cx="50%"
              cy="50%"
              innerRadius={40}
              outerRadius={60}
              paddingAngle={5}
              dataKey="value"
            >
              {portfolioHealthData.map((_, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip
              contentStyle={{
                backgroundColor: 'hsl(var(--card))',
                border: '1px solid hsl(var(--border))',
                borderRadius: '8px',
              }}
            />
          </PieChart>
        </ResponsiveContainer>
      </div>

      <div className="flex flex-wrap justify-center gap-3 md:gap-6 mt-2">
        {portfolioHealthData.map((item, index) => (
          <div key={item.name} className="flex items-center gap-2">
            <div
              className="w-3 h-3 rounded-full"
              style={{ backgroundColor: COLORS[index] }}
            />
            <span className="text-xs md:text-sm text-muted-foreground">
              {item.name} ({item.value})
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PortfolioChart;
